module.exports = __webpack_public_path__ + "img/15.71fbf360.png";